<template>
  <v-container fluid>
    <br>
    <h2 class="title-style">
      <v-icon
        left
        class="icon-style"
      >
        mdi-clipboard-text
      </v-icon>Sign Up List
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              dense
              class="mt-5"
              outlined
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="usersSignUp.headers"
        :items="usersSignUpList"
        :search="search"
        :single-expand="singleExpand"
        item-key="id"
        :expanded.sync="expanded"
        class="elevation-1 clickable"
      >
        <template #item="{ item, expand, isExpanded }">
          <tr>
            <td>{{ item.first_name }}</td>
            <td>{{ item.last_name }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.product_type }}</td>
            <td>
              <p>
                <font
                  :color="getColor(item.request_status)"
                  class="font-my-style"
                >
                  {{ item.request_status }}
                </font>
              </p>
            </td>
            <td>{{ item.created_at | convertToLocal }}</td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="white"
                @click.stop
                @click="expand(!isExpanded)"
              >
                <v-icon
                  v-if="!isExpanded"
                >
                  mdi-arrow-down-drop-circle
                </v-icon>
                <v-icon v-if="isExpanded">
                  mdi-arrow-up-drop-circle
                </v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <template #expanded-item="{ headers,item}">
          <td :colspan="headers.length">
            <v-row>
              <v-col
                cols="12"
                lg="6"
              >
                <v-card>
                  <v-toolbar
                    color="#37474F"
                    dark
                  >
                    <v-toolbar-title>Pricing Plan Type</v-toolbar-title>
                  </v-toolbar>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content class="ml-1">
                        <v-list-item-title>
                          <strong>
                            Pricing Plan: {{ item.pricing_plan_type }}
                          </strong>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
              <v-col
                cols="12"
                lg="6"
              >
                <v-card>
                  <v-toolbar
                    color="#37474F"
                    dark
                  >
                    <v-toolbar-title>Other Details</v-toolbar-title>
                  </v-toolbar>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content
                        v-if="item.other_details !== null"
                        class="ml-1"
                      >
                        <v-list-item-title
                          v-for="(value, name, index) in item.other_details"
                          :key="index"
                        >
                          <strong>
                            {{ name }}: {{ value }}
                          </strong>
                        </v-list-item-title>
                        <br>
                      </v-list-item-content>
                      <v-list-item-content
                        v-else
                      >
                        <v-list-item-title>
                          <strong>
                            <p style="color:#FF3700">No Details Available</p>
                          </strong>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>

      <br>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
<script>
  import moment from 'moment';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  export default {
    name: 'UsersSignUpList',
    components: {
      'centre-spinner': spinner,
    },
    filters: {
      convertToLocal (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        usersSignUp: {
          headers: [
            { text: 'First Name', align: 'start', value: 'first_name' },
            { text: 'Last Name', align: 'start', value: 'last_name' },
            { text: ' Email', value: 'email' },
            { text: 'Product Type', value: 'product_type' },
            { text: 'Request Type', value: 'request_status' },
            { text: 'Created At', value: 'created_at' },
            { text: 'More', value: 'More' },
          ],
        },
        expanded: [],
        singleExpand: true,
      };
    },
    computed: {
      usersSignUpList () {
        return this.$store.getters['users/getUsersSignUpList'];
      },
    },
    async mounted () {
      await this.getUsersSignUpList();
    },
    methods: {
      async getUsersSignUpList () {
        this.loading = true;
        await this.$store.dispatch('users/fetchUsersSignUpList', {
          params: {
            orderBy: 'created_at',
          },
        });
        this.loading = false;
      },
      getColor (status) {
        if (status === 'pending') {
          return '#C62828';
        } else if (status === 'inProgress') {
          return 'orange darken-3';
        } else if (status === 'cancelled') {
          return 'red';
        } else {
          return '#2E7D32';
        }
      },
    },
  };
</script>
<style scoped>
.font-my-style {
  font-weight: bold;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.v-data-table {
  background-color: #ECEFF1;
}
</style>
